import React from "react";
import FacebookIcon from "../Assets/SocialMediaIconSvg/facebook.svg";
import InstagramIcon from "../Assets/SocialMediaIconSvg/instagram.svg";
import WhatsappIcon from "../Assets/SocialMediaIconSvg/whatsapp.svg";
import XIcon from "../Assets/SocialMediaIconSvg/x.svg";
import GmailIcon from "../Assets/SocialMediaIconSvg/new-gmail.svg";
import BusinessImage from "../Assets/business-image-demo.png";

const GOOGLE_GOLD = "#FFD700";
const googleReviews = [
  "Staff was super friendly and made me feel welcome from the moment I walked in." +
    " I’ll definitely be coming back!",
  "Quick, professional, and exactly what I needed. Highly recommend this place to anyone" +
    " looking for great service!",
  "Sarah at the front desk was so helpful and patient, making the whole process easy and" +
    " stress-free for me.",
  "Our company event went off without a hitch—great communication and attention to detail" +
    " from start to finish.",
  "Best experience I’ve had in town. The staff went above and beyond to make sure I was" +
    " satisfied with everything.",
  "They explained everything clearly and checked in throughout. I felt supported and" +
    " valued as a customer.",
  "My family always gets great service here. Consistent quality and friendly faces every" +
    " single visit!",
  "They really care about their clients and it shows in every interaction. I always feel" +
    " appreciated.",
  "Staff took time to understand my needs and delivered perfectly. I couldn’t ask for" +
    " better results!",
  "Clean, welcoming environment and genuinely passionate team. I left feeling happy and" +
    " well taken care of.",
];
function getRandomReview() {
  return googleReviews[Math.floor(Math.random() * googleReviews.length)];
}

// Custom CSS for floating/rotating animation (now with X and Y movement)
const styles = `
@keyframes floatxy {
  0% {
    transform: translateY(0px) translateX(calc(var(--xamp, 0px) * 0)) rotate(var(--angle));
  }
  20% {
    transform: translateY(-10px) translateX(calc(var(--xamp, 0px) * 0.5)) rotate(calc(var(--angle) + 2deg));
  }
  50% {
    transform: translateY(0px) translateX(calc(var(--xamp, 0px) * 1)) rotate(var(--angle));
  }
  80% {
    transform: translateY(10px) translateX(calc(var(--xamp, 0px) * 0.5)) rotate(calc(var(--angle) - 2deg));
  }
  100% {
    transform: translateY(0px) translateX(calc(var(--xamp, 0px) * 0)) rotate(var(--angle));
  }
}
`;

const cards = [
  // Title card

  {
    icon: FacebookIcon,
    bg: "bg-blue-500",
    size: "w-20 h-20",
    style: { left: "10%", top: "10%", "--angle": "-8deg", "--xamp": "10px" },
    alt: "Facebook",
    duration: "4s",
    delay: "0s",
  },
  // Google Review Card 1 (with golden border)
  {
    isGoogleReview: true,
    bg: "bg-white",
    size: "w-64 h-36",
    style: {
      left: "25%",
      top: "20%",
      "--angle": "6deg",
      "--xamp": "-14px",
      border: `2.5px solid ${GOOGLE_GOLD}`,
    },
    duration: "5.8s",
    delay: "-2.2s",
  },
  {
    icon: InstagramIcon,
    bg: "bg-gradient-to-tr from-pink-500 to-yellow-400",
    size: "w-20 h-20",
    style: { left: "55%", top: "8%", "--angle": "4deg", "--xamp": "12px" },
    alt: "Instagram",
    duration: "4.5s",
    delay: "-2s",
  },
  {
    icon: GmailIcon,
    bg: "bg-white",
    size: "w-20 h-20",
    style: { left: "70%", top: "30%", "--angle": "-12deg", "--xamp": "-10px" },
    alt: "Gmail",
    duration: "6s",
    delay: "-1.5s",
  },
  {
    icon: BusinessImage,
    isImg: true,
    bg: "", // No background
    size: "w-40 h-40",
    style: { left: "8%", top: "55%", "--angle": "-3deg", "--xamp": "18px" },
    alt: "Business Image",
    duration: "7s",
    delay: "-2.5s",
    imgClass: "w-full h-full object-cover rounded-2xl",
  },
  {
    icon: WhatsappIcon,
    bg: "bg-green-400",
    size: "w-16 h-16",
    style: { left: "50%", top: "80%", "--angle": "15deg", "--xamp": "10px" },
    alt: "WhatsApp",
    duration: "6.5s",
    delay: "-2s",
  },
  {
    icon: XIcon,
    bg: "bg-white",
    size: "w-16 h-16",
    style: { left: "45%", top: "60%", "--angle": "-15deg", "--xamp": "-12px" },
    alt: "X",
    duration: "4.2s",
    delay: "-1.2s",
  },
  // Google Review Card 2 (with Copy Review button, no border, larger size)
  {
    isGoogleReview: true,
    hasCopy: true,
    bg: "bg-white",
    size: "w-80 h-44",
    style: {
      left: "60%",
      top: "50%",
      "--angle": "-7deg",
      "--xamp": "-16px",
    },
    duration: "6.2s",
    delay: "-3.1s",
  },
  {
    isTitle: true,
    bg: "bg-[#f3f4f6]", // light gray
    size: "w-64 h-10",
    style: {
      left: "50%",
      top: "45%",
      "--angle": "2deg",
      "--xamp": "10px",
    },
    duration: "5.2s",
    delay: "-1.5s",
  },
];

const AuthRightContent = () => {
  return (
    <div className="hidden lg:block relative w-full h-[500px]">
      <style>{styles}</style>
      <div className="absolute inset-0 bg-gradient-to-br rounded-3xl"></div>
      {/* Bento cards */}
      {cards.map((card, idx) =>
        card.isTitle ? (
          <div
            key={"title-card"}
            className={`bento-card absolute flex items-center justify-center rounded-2xl shadow-lg ${card.bg} ${card.size}`}
            style={{
              ...card.style,
              position: "absolute",
              animationDuration: card.duration,
              animationDelay: card.delay,
              animationName: "floatxy",
              animationTimingFunction: "ease-in-out",
              animationIterationCount: "infinite",
            }}
          >
            <span className="text-lg font-bold text-gray-800 text-center w-full">
              Google Reviews
            </span>
          </div>
        ) : card.isGoogleReview ? (
          <div
            key={"google-review-" + idx}
            className={`bento-card absolute flex flex-col items-center justify-center rounded-2xl shadow-lg ${card.bg} ${card.size}`}
            style={{
              ...card.style,
              position: "absolute",
              animationDuration: card.duration,
              animationDelay: card.delay,
              animationName: "floatxy",
              animationTimingFunction: "ease-in-out",
              animationIterationCount: "infinite",
            }}
          >
            <div className="flex space-x-1 mb-1">
              {[...Array(5)].map((_, i) => (
                <span key={i} style={{ color: GOOGLE_GOLD, fontSize: 20 }}>
                  ★
                </span>
              ))}
            </div>
            <div className="text-xs text-gray-700 text-center px-2 font-medium">
              {getRandomReview()}
            </div>
            {/* {card.hasCopy && (
              <button
                className="mt-2 px-4 py-1 bg-[#333C4D] rounded font-semibold text-xs shadow hover:bg-[#333C4D] transition text-white"
                onClick={() => {
                  navigator.clipboard.writeText(getRandomReview());
                }}
              >
                Copy Review
              </button>
            )} */}
          </div>
        ) : (
          <div
            key={idx}
            className={`bento-card absolute flex items-center justify-center rounded-2xl shadow-lg ${card.bg} ${card.size}`}
            style={{
              ...card.style,
              position: "absolute",
              animationDuration: card.duration,
              animationDelay: card.delay,
              animationName: "floatxy",
              animationTimingFunction: "ease-in-out",
              animationIterationCount: "infinite",
            }}
          >
            {card.isImg ? (
              <img
                src={card.icon}
                alt={card.alt}
                className={card.imgClass || "w-2/3 h-2/3 object-contain"}
              />
            ) : (
              <img
                src={card.icon}
                alt={card.alt}
                className="w-1/2 h-1/2 object-contain"
              />
            )}
          </div>
        )
      )}
    </div>
  );
};

export default AuthRightContent;
